module.exports = __webpack_public_path__ + "media/levelup1.f8ba4402.webm";